module.exports = __webpack_public_path__ + "img/wx拷贝.d440cbf1.png";